<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="ep-to-ses" size="lg"
             title="Add EP to Ses">
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
          </div>
        </div>
      </div>
      <div class="modal-content bg-white rounded box-shadow">

        <form action="" role="form">
          <div class="form-row">
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="district_id">Select District</label>
              <select v-model="ep_ses.district_id" @change="getJvcNo(ep_ses.district_id)"
                      class="form-control form-control-sm" name="district_id"
                      id="district_id">
                <option selected :value="''">Select a District</option>
                <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.id }} :
                  {{ district.district_desc }}
                </option>
              </select>
            </div>
            <div class="col-md-4 col-sm-6 col-lg-3">
              <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza <span
                  class="c-required">*</span></label>
              <select v-model="ep_ses.mouza_id" v-validate="'required'" class="form-control form-control-sm"
                      name="mouza_id" id="mouza_id">
                <option selected :value="''">Select a Mouza</option>
                <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} :
                  {{ mouza.mouza_desc }}
                </option>
              </select>
            </div>
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="jvc_id">Select JVC No <span
                  class="c-required">*</span></label>
              <select v-model="ep_ses.jvc_id" v-validate="'required'" class="form-control form-control-sm" name="jvc_id"
                      id="jvc_id">
                <option selected :value="''">Select a JVC No</option>
                <option v-for="(jvc_number, index) in jvc_numbers" :key="index" :value="jvc_number.id">
                  {{ jvc_number.jvc_no }}
                </option>
              </select>
              <div class="invalid-feedback">JVC No is required</div>
            </div>
          </div>
          <div class="form-row mt-2">
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="survey_worker_id">Survey worker <span
                  class="c-required">*</span></label>
              <select v-model="ep_ses.survey_worker_id" v-validate="'required'" class="form-control form-control-sm"
                      name="survey_worker_id"
                      id="survey_worker_id">
                <option selected :value="''">Select a Survey Worker</option>
                <option v-for="(worker, index) in workers" :key="index" :value="worker.id">
                  {{ worker.id }} : {{ worker.name }}
                </option>
              </select>
              <div class="invalid-feedback">Survey Worker is required</div>
            </div>
            <div class="col-md-4 col-sm-6 col-lg-4">
              <label class="col-form-label col-form-label-sm" for="entitle">Select EP Type</label>
              <select v-model="ep_ses.ep_type" class="form-control form-control-sm" name="entitle"
                      id="entitle">
                <option selected :value="''">Select EP Type</option>
                <option value="1">Titled</option>
                <option value="0">Non Titled</option>
              </select>

            </div>
          </div>

          <b-button class="form-control-sm mr-2 mt-3" size="sm" variant="success" @click.prevent="save()">Save
          </b-button>
          <b-button class="form-control-sm mt-3" size="sm" variant="danger" @click="$bvModal.hide('ep-to-ses')">
            Cancel
          </b-button>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  name: "presentAddressModal",
  props: ["ep_ses", "btn_edit"],
  data() {
    return {
      errorMessage: "",
      status: 0,
      message: "",
      validation_errors: {},
      show: false,
      districts: [],
      mouzas: [],
      workers: [],
      jvc_numbers: [],

    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/jvc-ses/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.districts = data.districts;
          this.workers = data.workers;
          this.jvc_numbers = data.jvc_numbers;
        }
      });
    },
    getJvcNo(district_id) {
      this.jvc_numbers = []
      this.mouzas = []
      this.ep_ses.jvc_id = '';
      this.ep_ses.mouza_id = '';
      if (district_id === '' || district_id === null) {
        this.jvc_numbers = [];
        this.mouzas = [];
      } else {
        http.get("api/jvc-ses/getJvcNo/" + district_id).then(response => {
          if (!response.error) {
            let data = response.data;
            this.jvc_numbers = data.jvc_numbers;
            this.mouzas = data.mouzas;
          }
        });
      }
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.post("api/jvc-ses/store", this.ep_ses)
              .then(response => {
                if (!response.data.error) {
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                  this.$bvModal.hide("ep-to-ses");
                  this.$emit("search");
                } else {
                  this.$bvToast.toast(response.data.message, {
                    title: "Warning",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                  this.$bvModal.hide("ep-to-ses");
                }
              })
              .catch(error => {
                this.validation_errors = error.response.data.errors;
                this.show = true;
                this.hide();
              });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
